import {ConversationBuilder} from "../common/objects/ConversationBuilder";
import _ from "lodash";
import {handleTypeNames, messageDirection, supportedSourcesForViewHtmlAndPhotos} from "_constants";
import {getVotingOrganization} from "_helpers";
import {isAdminMessageView} from "../views/Messages/MessageDetails/Utilities/MessageDetailsUtils";

/**
 * @param conversationList {array}
 */
export function buildOriginalConversation(conversationList) {
    const conversationArr = [];
    conversationList.map(conversation => {
        const builder = new ConversationBuilder();
        builder.setId(_.get(conversation, 'id'));
        builder.setAuthorEmail(_.get(conversation, 'authorEmail') || _.get(conversation, 'authorPhoneNumber'));
        builder.setAuthorName(_.get(conversation, 'authorPhoneNumber') || _.get(conversation, 'authorName') || 'User');
        builder.setPhoneNumber(_.get(conversation, 'authorPhoneNumber'));
        builder.setSubject(_.get(conversation, 'emailSubject'));
        builder.setText(_.get(conversation, 'htmlBody') || '-');
        builder.setRecipientEmail(_.get(conversation, 'recipientPhoneNumber') || _.get(conversation, 'recipientEmail'));
        builder.setCreatedDate(_.get(conversation, 'createdDate'));
        builder.setAttachments(_.get(conversation, 'attachments'));
        builder.setIsTrendsSource(false);
        builder.setAssignee(_.get(conversation, 'assignee'));
        builder.setCurrentPage(_.get(conversation, 'currentPage'));
        builder.setAlternativePhoneNumbers(_.get(conversation, 'additionalPhoneNumbers'));
        builder.setAlternativeEmails(_.get(conversation, 'additionalEmails'));
        builder.setCurrentPage(_.get(conversation, 'currentPage'));
        builder.setOther(_.get(conversation, 'other'));
        conversationArr.push(builder.conversation);
    })
    return conversationArr;
}

/**
 * @param conversationList {array}
 */
export function buildConversation(conversationList) {
    const conversationArr = [];
    conversationList.map(conversation => {
        const builder = new ConversationBuilder();
        builder.setId(_.get(conversation, 'id'));
        builder.setAuthorEmail(_.get(conversation, 'authorPhoneNumber') || _.get(conversation, 'authorId'));
        builder.setAuthorName(_.get(conversation, 'authorPhoneNumber') || _.get(conversation, 'author') || 'User');
        builder.setText(_.get(conversation, 'text') || '-');
        builder.setDirection(_.get(conversation, 'direction'));
        builder.setCreatedDate(_.get(conversation, 'dateCreatedFromSource') || _.get(conversation, 'createdDate') || '-');
        builder.setIsTrendsSource(true);
        conversationArr.push(builder.conversation);
    })
    return conversationArr;
}

/**
 * @param conversation {object}
 * @param message {object}
 * @returns {string}
 */
export function getMessageDirection(conversation, message) {
    const authorId = _.get(message, 'authorId');
    const author = _.get(message, 'author');
    const direction = _.get(conversation, 'direction');
    const authorEmail = _.get(conversation, 'authorEmail');
    const authorName = _.get(conversation, 'authorName');
    const isTrendsSource = _.get(conversation, 'isTrendsSource');

    if(isTrendsSource) return direction;
    if((!authorEmail || !authorId) && (!author || !authorName)) return undefined;
    return ((authorEmail === authorId) || (author === authorName)) ? messageDirection.INCOMING : messageDirection.OUTGOING;
}

/**
 * @param message {object}
 * @param conversationItem {object}
 * @returns {string|undefined|null}
 */
export function getFullName(message, conversationItem) {
    if (isUserMessage(message, conversationItem)) {
        return _.get(message, 'author') || _.get(conversationItem, 'authorName');
    } else {
        return null;
    }
}

export function isUserMessage(message, conversationItem) {
    const messageExternalId = _.get(conversationItem, 'id');
    const authorEmail = _.get(conversationItem, 'authorEmail');
    const authorId = _.get(message, 'authorId');
    const externalUniqueId = _.get(message, 'externalUniqueId');
    return authorId === authorEmail || externalUniqueId === messageExternalId;
}

/**
 * @param direction {string}
 * @returns {string}
 */
export function getBackgroundColor(direction) {
    return (_.toString(direction).toUpperCase() === messageDirection.INCOMING) ? 'teal' : 'grey';
}

/**
 * @param author {string}
 * @param direction {string}
 * @returns {string}
 */
export function getAuthor(author, direction) {
    const org = getVotingOrganization();
    return (_.toString(direction).toUpperCase() === messageDirection.INCOMING) ?
        author : (_.get(org, 'name') || author);
}

/**
 * @param direction {string}
 * @returns {number}
 */
export function getInitialsCount(direction) {
    return (_.toString(direction).toUpperCase() === messageDirection.INCOMING) ? 2 : 1;
}

/**
 * @param assignee {object}
 * @returns {string}
 */
export function processAssignee(assignee) {
    const placeholder = 'None';
    if(_.isEmpty(assignee)) return placeholder;
    const name = _.get(assignee, 'name');
    const email = _.get(assignee, 'email');
    if(_.isEmpty(name) || _.isEmpty(email)) return placeholder;
    return `${name} ${email}`;
}

export function shouldShowCopyIcon(direction) {
    return (_.toString(direction).toUpperCase() === messageDirection.INCOMING)
}

/**
 * @param sourceName {string}
 * @param handleName {string}
 * @param isInApp {boolean}
 * @returns {boolean}
 */
export function isViewOriginalSupported(sourceName, handleName, isInApp) {
    return isInApp && supportedSourcesForViewHtmlAndPhotos.includes(sourceName) && !isMetaMentions(handleName);
}

/**
 * @param handleName {string}
 * @returns {boolean}
 */
export function isMetaMentions(handleName) {
    let metaMentionsPattern = new RegExp("(Instagram|Facebook) (Mentions).*");
    return metaMentionsPattern.test(handleName || '');
}

/**
 * @param handleName
 * @returns {boolean}
 */
export function isTiktokShopPost(handleName) {
    return handleName === handleTypeNames.TIKTOK_SHOP_POST;
}

export const responseFieldState = {
    RESPONSE_OPTIONS: 'RESPONSE_OPTIONS',
    EMPTY_FIELD: 'EMPTY_FIELD',
    NONE: 'NONE',
}

/**
 * @param responseOptions {array}
 * @returns {string}
 */
export function responseField(responseOptions) {
    const isEmpty = _.isEmpty(responseOptions) || _.isEmpty(responseOptions[0]);
    const isAdminMessage = isAdminMessageView();
    if(isEmpty && isAdminMessage) {
        return responseFieldState.EMPTY_FIELD;
    } else if (isEmpty && !isAdminMessage) {
        return responseFieldState.NONE;
    }
    return responseFieldState.RESPONSE_OPTIONS;
}

/**
 * @param responseOptions {array}
 * @returns {boolean}
 */
export function hasResponseOptions(responseOptions) {
    return responseField(responseOptions) === responseFieldState.RESPONSE_OPTIONS;
}
/**
 * @param handleName
 * @returns {boolean}
 */
export function isSocialFeed(handleName) {
    return handleName === handleTypeNames.SOCIAL_FEED;
}